import axios from 'axios';
import storage from './storage';
import { BASE_URL } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const fetch = async (endpoint, method, data, options = { ContentType: 'application/json' }) => {
  const token = await storage.get('token');
  const URL = `${BASE_URL}/${endpoint}`;
  const headers = {
    'Content-Type': options.ContentType,
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return axios({
    url: URL,
    method,
    headers,
    data,
  });
};

export const fetchExternal = async (
  endpoint,
  method,
  data,
  options = { ContentType: 'application/json' }
) => {
  const token = await storage.get('token');
  const URL = `${process.env.REACT_APP_BASE_URL_GW_API_V2}/${endpoint}`;
  const headers = {
    'Content-Type': options.ContentType,
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return axios({
    url: URL,
    method,
    headers,
    data,
  });
};
